import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AffiliatePortalBlockedNotice from "../../affiliate/components/AffiliatePortalBlockedNotice";
import { AffiliateAuthContext } from "../../affiliate/context/AffiliateAuthContext";
import { AuthContext } from "../context/AuthContext";
import { surfaces, effects } from "../../design-system/tokens";
import AffiliateNavbar from "../../affiliate/components/AffiliateNavbar";
import { getPortalBasePath } from "../../affiliate/utils/portalKind";

const AffiliateProtectedRoute = ({ children }) => {
  const { affiliateAuth } = useContext(AffiliateAuthContext);
  const { auth, isHydrated } = useContext(AuthContext);
  const location = useLocation();
  // /affiliate and /partner are interchangeable aliases — keep the visitor on
  // the prefix they entered with for login and onboarding round-trips.
  const basePath = getPortalBasePath(location?.pathname);

  if (affiliateAuth.isChecking) return null;

  if (affiliateAuth.isPortalBlocked) {
    return (
      <div className={`min-h-screen ${surfaces.modernApp} transition-colors duration-300 relative`}>
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
          <div className={effects.backgroundGlowBlue}></div>
          <div className={effects.backgroundGlowSky}></div>
        </div>
        <div className="relative z-10">
          <AffiliateNavbar showTabs={false} />
          <AffiliatePortalBlockedNotice message={affiliateAuth.portalBlockedMessage} />
        </div>
      </div>
    );
  }

  if (!affiliateAuth.isAuthenticated) return <Navigate to={`${basePath}/login`} replace />;

  // Prefer AuthContext once hydrated so completing onboarding (which clears the
  // flag there) isn't undone by a stale affiliate-check payload.
  const mustCompleteOnboarding =
    isHydrated && auth
      ? !!auth.mustCompleteOnboarding
      : !!affiliateAuth.user?.must_complete_onboarding;

  if (mustCompleteOnboarding) {
    const returnTo = encodeURIComponent(`${basePath}/dashboard/coupons`);
    return <Navigate to={`/edit/complete-account?returnTo=${returnTo}`} replace />;
  }

  return children;
};

export default AffiliateProtectedRoute;
